const sizes = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-8 h-8 text-[12px]',
  md: 'w-10 h-10 text-[14px]',
  lg: 'w-12 h-12 text-[16px]',
};

// Deterministic color from name
const palette = [
  'bg-[var(--color-recovery-500)] text-white',
  'bg-[var(--color-action-500)] text-white',
  'bg-[var(--color-insight-500)] text-white',
  'bg-[var(--color-success-500)] text-white',
  'bg-[var(--color-warm-700)] text-[var(--color-cream-50)]',
];

function getInitials(name = '') {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function hashColor(name = '') {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return palette[h % palette.length];
}

export default function Avatar({ name = '', size = 'md', className = '' }) {
  return (
    <div
      className={`
        ${sizes[size]} ${hashColor(name)}
        rounded-full flex items-center justify-center
        font-semibold shrink-0 select-none
        ${className}
      `}
      title={name}
    >
      {getInitials(name)}
    </div>
  );
}
